module.exports = __webpack_public_path__ + "static/img/repast04.01066b70.jpg";